<template>
<div>
  <Grid name="modalsubactivitiesGrid" ref="modalsubactivitiesGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import States from '@/components/Lists.js'
export default {
  name: 'Actividades',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [{
        api: 'activities/lst',
        field: 'activity_id'
      }],
      schemaModelFields: {},
      url: 'subactivities',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectItem
        }
      }, {
        field: 'id',
        title: 'ID'
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'activity_id',
        title: 'Actividade',
        values: []
      }, {
        field: 'state',
        title: 'Estado',
        width: '180px',
        values: States.states
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    selectItem(e) {
      e.preventDefault()
      var grid = this.$refs.modalsubactivitiesGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    }
  }
}
</script>
